import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { UserContext } from "../../context/user-context";
import { SessionContext } from "../../context/session-context";

import getMonthlySpend from '../../functions/getMonthlySpend';

import AccountOrderInterface from './accountOrderInterface';

export default function MyDetailsPanel(props) {
  
  const useStyles = makeStyles({
    root:{
      width: props.width,
      minWidth: 380, 
      maxHeight: 500
    },
    });
  const classes = useStyles();
  const [sState] = useContext(SessionContext);
  const [uState] = useContext(UserContext);

  const [companyName, setCompanyName] = useState(uState.company.companyname);
  const [monthlybalance, setMonthlybalance] = useState(0);
  const [creditLimit, setCreditLimit] = useState(0);

  useEffect(() => {
    setCreditLimit(uState.company.companycreditlimit);
    getMonthlySpend(uState.company.companyid).then((spent) => {
    setMonthlybalance(spent);
    });
  },[]);


  useEffect(() => {
    setMonthlybalance(sState.monthlybalance);
  },[sState.monthlybalance]);


    //Usage summary 
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={8}>
            <Box fontWeight="fontWeightBold" fontSize={24}><p>{companyName}</p></Box>
        </Grid>
        <Grid item xs={4}>
            <Box fontWeight="fontWeightBold" fontSize={16}>Usage Summary</Box>
            <Grid container>
                <Grid item xs={8}>Account Credit Limit:</Grid><Grid item xs={4}>£{creditLimit}</Grid>
                <Grid item xs={8}>Current Monthly Balance:</Grid><Grid item xs={4}>£{monthlybalance}</Grid>
            </Grid>
        </Grid>
        <Grid item xs={8} />
        <Grid item xs={12}><AccountOrderInterface /></Grid>
      </Grid>
    </div> 
  );
}